var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg28 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "28")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.5,8.49a19.38,19.38,0,0,1,3.27.77,17,17,0,0,1,11,10c.74,1.78,1.37,3.6,2.13,5.36.57,1.32.19,2-1.14,2.5-1.71.6-3.4,1.27-5.06,2-1.21.53-2,.32-2.42-1s-1-2.56-1.5-3.84c-2.15-5.5-6.23-7.68-12.05-6.33a12.85,12.85,0,0,0-7.91,5.25A9.09,9.09,0,0,0,34.3,32c.89,1.92.79,2-1.25,2-1.77,0-3.54,0-5.31,0-1.41,0-2.65.32-3.08-1.33a17.83,17.83,0,0,1,2.13-14A22,22,0,0,1,35,11,22.26,22.26,0,0,1,48.5,8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72.18,41.32c0-3.53-1.8-5.28-5.28-5.28h-43c-4.48,0-6,1.5-6,6,0,11.57.05,23.14,0,34.71,0,2.83.85,4.89,3.53,6h47.3a5.26,5.26,0,0,0,3.49-5.2C72.17,65.46,72.2,53.39,72.18,41.32ZM49,59.81a2.53,2.53,0,0,0-1,2.35c.06,2.75,0,5.5,0,8.25,0,2.29-1.45,3.44-3.67,3-1.57-.28-2-1.46-2.1-2.81-.08-1.54,0-3.08,0-4.62h0a21.43,21.43,0,0,1,0-3,3.75,3.75,0,0,0-1.53-3.68,6,6,0,0,1-1.28-7,6.25,6.25,0,0,1,11.81,1.31A5.93,5.93,0,0,1,49,59.81Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg28, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/28.69e384f3.svg";
export { ForwardRef as ReactComponent };